package com.parmartechnologies.core.feature.currency.model

import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.extension.UniqueueID
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Currency(
    @SerialName("currency_symbol") var symbol: String = "",
    @SerialName("name") var name: String = "",
    @SerialName("code") var code: String = "",
    @SerialName("country_code") var countryCode: String = "",
    @SerialName("name_plural") var name_plural: String = "",
    @SerialName("decimal_digits") var decimal_digits: Float = 0f,
    @SerialName("rounding") var rounding: Float = 0f,
): BaseDataClass()